<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yEhhB8/tc-custom/9781911591962.jpg?1726617321254" alt="This image is the cover for the book Family of the Empire, The Kilmaster Family Sagas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family of the Empire, The Kilmaster Family Sagas
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The son of a Yorkshire coal miner seeks a new life with the British Army in the second novel of this historical family saga.</b></p><p> Born and raised in Yorkshire, England, Probyn Kilmaster wants more out of life than to follow his father down the pit. He has always admired his convention-defying Aunt Kit and, inspired by her, runs away to join the army. Though he is eager to see the world, war is brewing in South Africa, and his first foreign posting is unlike anything he could imagine. </p><p><b>Stationed abroad, Probyn meets an older woman who persuades him to have an unofficial wedding ceremony. But in the aftermath of the whirlwind, he soon yearns for escape. Narrowly avoiding court martial, Probyn returns to England where he hopes to make peace with his family and settle down. Yet even after finding a wife, his happiness is threatened by mistakes from his past . . . </b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheelagh Kelly
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62530f2d